import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d37b93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale-refund" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = { class: "refund-show-goods" }
const _hoisted_4 = { class: "select-goods" }
const _hoisted_5 = { class: "exchange-address add-refund-content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-refund-title" }, "My Shipping Address：", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_9 = {
  key: 2,
  class: "add-refund-content"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-refund-title" }, "Refund Amount:", -1))
const _hoisted_11 = {
  key: 0,
  class: "refund-tip"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, "Refund rules:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "1. ''Refund only'' is only available for partially received or unreceived orders, ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "2. Once refunded, order cannot be restored, other discount & promotions may not be available again. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "3. The refund amount can only be the actual paid amount, vouchers and coupons cannot be refunded once used, while Kilimall coins will be returned. ", -1))
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "btn" }
const _hoisted_18 = {
  key: 0,
  class: "refund-tip"
}
const _hoisted_19 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AfterGoodsCard = _resolveComponent("AfterGoodsCard")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_KiliButton = _resolveComponent("KiliButton")!
  const _component_AfterType = _resolveComponent("AfterType")!
  const _component_afterFileRemark = _resolveComponent("afterFileRemark")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_BottomBtn = _resolveComponent("BottomBtn")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_Sku = _resolveComponent("Sku")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: $setup.serviceType.title,
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: $setup.SkipPath,
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToRule && $setup.goToRule(...args)))
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["title", "skipPath"]),
    _createVNode(_component_van_form, {
      class: "refund-content",
      "validate-first": "",
      onFailed: $setup.onFailed,
      onSubmit: $setup.onSubmit,
      ref: "refForm",
      clearable: "",
      autofocus: "",
      "show-error-message": false,
      "show-error": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AfterGoodsCard, {
            isNum: !$setup.isBatOnly,
            goodsData: $setup.goodsData,
            onHandleNum: $setup.handleNum
          }, null, 8, ["isNum", "goodsData", "onHandleNum"])
        ]),
        _createVNode(_component_van_field, {
          modelValue: $setup.serviceType.title,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.serviceType.title) = $event)),
          class: "value-boo value-normal",
          "input-align": "right",
          "is-link": "",
          readonly: "",
          name: "serviceTitle",
          label: "Service Type:",
          "label-width": "30%",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeReasonList('type')))
        }, null, 8, ["modelValue"]),
        ($setup.serviceType.type == '2')
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 0,
              modelValue: $setup.infoData.statusVal,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.infoData.statusVal) = $event)),
              class: _normalizeClass(["value-normal", $setup.infoData.statusVal ? 'value-boo' : '']),
              "is-link": "",
              "input-align": "right",
              label: "Receipt status:",
              "label-width": "30%",
              name: "statusVal",
              readonly: "",
              placeholder: "Please select the arrival status",
              rules: [{ required: true, message: 'Please select the arrival status' }],
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeReasonList('status')))
            }, null, 8, ["modelValue", "class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_field, {
          modelValue: $setup.infoData.reasonVal,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.infoData.reasonVal) = $event)),
          class: _normalizeClass(["value-normal", $setup.infoData.reasonVal ? 'value-boo' : '']),
          "input-align": "right",
          "is-link": "",
          readonly: "",
          label: "Reason:",
          "label-width": "30%",
          name: "reasonVal",
          placeholder: "Please select the reason for after-sales",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changeReasonList('reason'))),
          rules: [{ required: true, message: 'Please select the reason for after-sales' }]
        }, null, 8, ["modelValue", "class"]),
        ($setup.serviceType.type == '4')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_van_field, {
                  class: "exchange",
                  "input-align": "right",
                  "is-link": "",
                  label: "Exchange goods:",
                  "label-width": "35%",
                  name: "exchange",
                  readonly: "",
                  placeholder: JSON.stringify($setup.selectGoods) != '{}' ? 'Reselect' : 'Choose an exchange item',
                  onClick: $setup.handleExchange
                }, null, 8, ["placeholder", "onClick"]),
                (JSON.stringify($setup.selectGoods) != '{}')
                  ? (_openBlock(), _createBlock(_component_AfterGoodsCard, {
                      key: 0,
                      goodsData: $setup.selectGoods
                    }, null, 8, ["goodsData"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_KiliButton, {
                    plain: "",
                    textColor: "#DD3131",
                    bordersColor: "#DD3131",
                    radiusSize: "8px",
                    title: "Edit",
                    onClick: $setup.editAddress
                  }, null, 8, ["onClick"])
                ]),
                _createVNode(_component_AfterType, {
                  data: $setup.addressData,
                  lefterSize: "0.3rem"
                }, _createSlots({ _: 2 }, [
                  _renderList($setup.addressData, (item) => {
                    return {
                      name: "titleLeft",
                      fn: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("span", null, "+" + _toDisplayString($setup.phoneCode) + " ", 1),
                        _createElementVNode("span", null, _toDisplayString(item.phone), 1)
                      ])
                    }
                  })
                ]), 1032, ["data"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (($setup.serviceType.type == '2') || $setup.serviceType.type == '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_van_field, {
                modelValue: $setup.infoData.KShVal,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.infoData.KShVal) = $event)),
                ref: "kshInputRef",
                label: "KSh",
                placeholder: "Please enter the refund amount",
                type: "number",
                clearable: "",
                disabled: "",
                "format-trigger": "onBlur",
                name: "validatorKSh",
                formatter: $setup.formatter,
                rules: [{ required: true, message: 'Please enter the refund amount' },{ validator:$setup.validatorKSh}]
              }, null, 8, ["modelValue", "formatter", "rules"]),
              _createElementVNode("span", null, "Up to KSh " + _toDisplayString($setup.maxKSH) + " can be applied", 1)
            ]))
          : _createCommentVNode("", true),
        (($setup.serviceType.type == '2') || $setup.serviceType.type != '2')
          ? (_openBlock(), _createBlock(_component_afterFileRemark, {
              key: 3,
              class: "add-refund-content",
              fileList: $setup.fileList,
              imgPathData: $setup.imgPathData,
              teaxAreaVal: $setup.infoData.teaxAreaVal,
              "onUpdate:teaxAreaVal": _cache[8] || (_cache[8] = ($event: any) => (($setup.infoData.teaxAreaVal) = $event)),
              onHandleUpload: $setup.handleUpload,
              onDelFile: $setup.delFile
            }, null, 8, ["fileList", "imgPathData", "teaxAreaVal", "onHandleUpload", "onDelFile"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onFailed", "onSubmit"]),
    _createVNode(_component_BottomBtn, {
      onClick: $setup.handleBtn,
      btnData: $setup.btnData
    }, null, 8, ["onClick", "btnData"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.showAction,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.showAction) = $event)),
      title: $setup.popTitle,
      closeable: true,
      round: false,
      onClose: $setup.sheetClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_radio_group, {
          modelValue: $setup.reasonRad,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.reasonRad) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reasonList, (item) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    title: item.title,
                    clickable: "",
                    onClick: ($event: any) => ($setup.handleReasonRadio(item))
                  }, {
                    "right-icon": _withCtx(() => [
                      _createVNode(_component_van_radio, {
                        name: item.id
                      }, null, 8, ["name"])
                    ]),
                    _: 2
                  }, 1032, ["title", "onClick"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "title", "onClose"]),
    _createVNode(_component_Sku, {
      modelValue: $setup.skuShow,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.skuShow) = $event)),
      sku: $setup.goods.spec_list,
      goods: $setup.goods,
      variation: $setup.variation,
      noJump: "",
      onSkuSelected: $setup.skuSelected,
      onAddCart: $setup.addCart
    }, null, 8, ["modelValue", "sku", "goods", "variation", "onSkuSelected", "onAddCart"]),
    _createVNode(_component_van_popup, {
      show: $setup.showDialog,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (($setup.showDialog) = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        ($setup.serviceType.type == '2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_16))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_KiliButton, {
            plain: "",
            textColor: "#666666",
            bordersColor: "#99999",
            title: "Cancel",
            onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.showDialog = false))
          }),
          _createVNode(_component_KiliButton, {
            textColor: "#E04545",
            bordersColor: "#E04545",
            title: "Continue ",
            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.handleContinue(false)))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: $setup.showaMountDialog,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (($setup.showaMountDialog) = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        ($setup.needKSH && $setup.infoData.KShVal < $setup.maxKSH)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Are you sure you want to apply amount that is less than the full amount? "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_KiliButton, {
            plain: "",
            textColor: "#666666",
            bordersColor: "#99999",
            title: "Cancel",
            onClick: $setup.handleNotConfirm
          }, null, 8, ["onClick"]),
          _createVNode(_component_KiliButton, {
            textColor: "#E04545",
            bordersColor: "#E04545",
            title: "Continue ",
            onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.handleContinue($setup.serviceType.type == '2')))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}